import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL_TOKEN } from '../providers/api-base-url.provider';
import { APIBaseURLOption } from '../interfaces/api-base-url-option.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  public readonly url = `${this.baseUrlProvider.UIRootBase}`;
  public headers: { [key: string]: string } = {
    'Content-Type': 'application/json',
  };

  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE_URL_TOKEN)
    private readonly baseUrlProvider: APIBaseURLOption
  ) {}

  public destroyAuthentication() {
    const url = `${this.url}/authentication/destroy`;

    return this.httpClient.post(url, null, {
      headers: new HttpHeaders({ ...this.headers, }),
      responseType: 'text',
      observe: 'body',
      withCredentials: true,
    });
  }

  public authenticateUser(idToken: string) {
    const url = `${this.url}/authentication/user`;

    return this.httpClient.post(
      url,
      { idToken },
      {
        headers: this.headers,
        responseType: 'text',
        observe: 'body',
      }
    );
  }
}
